import React from "react";
import CardMenu from "components/card/CardMenu";
import { FaArchive, FaEdit, FaTrash } from "react-icons/fa";
import { Actions } from "constants/actions";

interface CategoryCardProps {
  slug: string;
  image: string;
  name: string;
  description: string;
  openModal: (action: Actions, data?: any) => void;
}

const CategoryCard: React.FC<CategoryCardProps> = (props) => {
  const { slug, image, name, description, openModal } = props;

  return (
    <div className="flex w-full items-center justify-between rounded-2xl bg-white p-3 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
      <div className="flex w-full items-center">
        <div>
          {image ? (
            <img
              className="h-[83px] w-[83px] rounded-lg object-cover object-center"
              src={`${process.env.REACT_APP_PUBLIC_URL}/${image}`}
              alt={name}
            />
          ) : (
            <div className="flex h-[83px] w-[83px] items-center justify-center rounded-xl bg-brand-50 bg-opacity-25">
              <FaArchive className="h-5 w-5 text-brand-500" />
            </div>
          )}
        </div>
        <div className="ml-4 flex flex-[1] items-center justify-between">
          <p className="line-clamp-2 text-base font-bold text-navy-700 dark:text-white">
            {name}
          </p>
          <div className="flex items-center gap-3">
            <CardMenu
              children={
                <>
                  <button
                    className="mt-2 flex cursor-pointer items-center gap-2 pt-1 text-brand-500 hover:font-medium hover:text-brand-600"
                    onClick={() =>
                      openModal(Actions.UPDATE, {
                        slug,
                        image,
                        name,
                        description,
                      })
                    }
                  >
                    <span>
                      <FaEdit />
                    </span>
                    Edit
                  </button>
                  <button
                    className="mt-2 flex cursor-pointer items-center gap-2 pt-1 text-red-500 hover:font-medium hover:text-red-600"
                    onClick={() => {
                      openModal(Actions.DELETE, {
                        slug,
                        image,
                        name,
                        description,
                      });
                    }}
                  >
                    <span>
                      <FaTrash />
                    </span>
                    Hapus
                  </button>
                </>
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryCard;
